<template>
  <button
    :class="buttonClasses"
    :disabled="disabled"
    :title="title"
    @click="pageChange"
  >
    <div v-if="loading">loading</div>
    <span v-else v-html="html" />
  </button>
</template>

<script>
export default {
  name: 'VueAdsPageButton',
  props: {
    page: {
      type: [Number, String],
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    html: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disableStyling: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses() {
      if (this.disableStyling) {
        return {}
      }
      return {
        'focus:outline-none': true,
        'ml-1': true,
        'leading-normal': true,
        'w-6': true,
        'bg-green-500': this.active,
        'text-white': this.active,
        'cursor-default': this.active || this.disabled,
        'bg-gray-200': this.disabled && this.page !== '...',
        'text-gray': this.disabled && this.page !== '...',
        'hover:bg-gray-100': !this.active && !this.disabled,
      }
    },
  },
  methods: {
    pageChange() {
      if (this.page === '...' || this.disabled || this.active) {
        return
      }
      this.$emit('page-change')
    },
  },
}
</script>
